export default {
  'pages.houseUser.title': 'House User Management',
  'pages.houseUser.subTitle':
    'Manage owners, tenants and visitors in the community',
  'pages.houseUser.detail.title': 'User Details',
  'pages.houseUser.detail.breadcrumb': 'User Details',
  'pages.houseUser.detail.tab.properties': 'User Properties',
  'pages.houseUser.detail.tab.houses': 'Property Information',
  'pages.houseUser.detail.tab.rentInfo': 'Rental Information',
  'pages.houseUser.detail.tab.tenants': 'Tenant Management',
  'pages.houseUser.detail.tab.parking': 'Parking Spaces',
  'pages.houseUser.detail.tab.services': 'Activated Services',
  'pages.houseUser.detail.tab.files': 'User Documents',
  'pages.houseUser.detail.tab.contacts': 'Emergency Contacts',
  'pages.houseUser.detail.card.accountInfo': 'Account Information',
  'pages.houseUser.detail.card.basicInfo': 'Basic Information',
  'pages.houseUser.detail.card.contactInfo': 'Contact Information',
  'pages.houseUser.detail.card.residenceInfo': 'Residence Information',
  'pages.houseUser.detail.card.remarks': 'Remarks',
  'pages.houseUser.detail.card.parkingList': 'Parking Space List',
  'pages.houseUser.detail.label.username': 'Username',
  'pages.houseUser.detail.label.role': 'Role',
  'pages.houseUser.detail.label.status': 'Status',
  'pages.houseUser.detail.label.name': 'Name',
  'pages.houseUser.detail.label.gender': 'Gender',
  'pages.houseUser.detail.label.birthDate': 'Date of Birth',
  'pages.houseUser.detail.label.idCard': 'ID Card Number',
  'pages.houseUser.detail.label.phone': 'Phone Number',
  'pages.houseUser.detail.label.email': 'Email Address',
  'pages.houseUser.detail.label.moveInDate': 'Move-in Date',
  'pages.houseUser.detail.label.moveOutDate': 'Move-out Date',
  'pages.houseUser.detail.label.postalCode': 'Postal Code',
  'pages.houseUser.detail.label.address': 'Detailed Address',
  'pages.houseUser.detail.button.edit': 'Edit',
  'pages.houseUser.detail.button.view': 'View',
  'pages.houseUser.detail.button.addHouse': '+ Add House',
  'pages.houseUser.detail.button.addContact': 'Add Contact',
  'pages.houseUser.detail.button.addTenant': '+ Add Tenant',
  'pages.houseUser.detail.button.unbind': 'Unbind',
  'pages.houseUser.detail.button.bindParking': 'Bind parking',
  'pages.houseUser.detail.button.delete': 'Delete',
  'pages.houseUser.detail.parking.bindModalTitle': 'Bind parking space',
  'pages.houseUser.detail.parking.searchPlaceholder':
    'Search by parking number',
  'pages.houseUser.detail.parking.selectHint': 'Select a parking space to bind',
  'pages.houseUser.detail.parking.selectedSummary':
    'Selected: {parkingNumber} ({buildingName} / {floorName})',
  'pages.houseUser.detail.parking.unbindConfirm':
    'Unbind this parking space from the current owner?',
  'pages.houseUser.detail.parking.bindSuccess': 'Bound successfully',
  'pages.houseUser.detail.parking.bindFailed': 'Bind failed',
  'pages.houseUser.detail.parking.unbindSuccess': 'Unbound successfully',
  'pages.houseUser.detail.parking.unbindFailed': 'Unbind failed',
  'pages.houseUser.detail.parking.selectFirst':
    'Search and select a parking space first',
  'pages.houseUser.detail.parking.status.unbound': 'Unbound',
  'pages.houseUser.detail.parking.status.boundSelf': 'Bound',
  'pages.houseUser.detail.parking.status.boundOther': 'Bound to another owner',
  'pages.houseUser.detail.parking.popconfirmOk': 'OK',
  'pages.houseUser.detail.parking.popconfirmCancel': 'Cancel',
  'pages.houseUser.detail.table.house.buildingName': 'Building Name',
  'pages.houseUser.detail.table.house.floor': 'Floor',
  'pages.houseUser.detail.table.house.houseNumber': 'House Number',
  'pages.houseUser.detail.table.house.houseType': 'House Type',
  'pages.houseUser.detail.table.house.area': 'House Area',
  'pages.houseUser.detail.table.house.status': 'House Status',
  'pages.houseUser.detail.table.house.operations': 'Operations',
  'pages.houseUser.detail.table.contact.contactName': 'Contact Name',
  'pages.houseUser.detail.table.contact.contactPhone': 'Contact Phone',
  'pages.houseUser.detail.table.contact.relationship': 'Relationship to Owner',
  'pages.houseUser.detail.table.contact.remarks': 'Remarks',
  'pages.houseUser.detail.table.contact.createdTime': 'Created Time',
  'pages.houseUser.detail.table.contact.operations': 'Operations',
  'pages.houseUser.detail.status.enabled': 'Enabled',
  'pages.houseUser.detail.status.disabled': 'Disabled',
  'pages.houseUser.detail.status.other': 'Other',
  'pages.houseUser.detail.status.active': 'Active',
  'pages.houseUser.detail.status.inactive': 'Inactive',
  'pages.houseUser.detail.status.available': 'Available',
  'pages.houseUser.detail.status.sold': 'Sold',
  'pages.houseUser.detail.status.rented': 'Rented',
  'pages.houseUser.detail.status.reserved': 'Reserved',
  'pages.houseUser.detail.status.expired': 'Expired',
  'pages.houseUser.detail.status.pending': 'Pending',
  'pages.houseUser.detail.status.expiring': 'Expiring Soon',
  'pages.houseUser.detail.status.vacant': 'Vacant',
  'pages.houseUser.detail.status.occupied': 'Occupied',
  'pages.houseUser.detail.status.selfOccupied': 'Self-occupied',
  'pages.houseUser.detail.status.underRepair': 'Under Repair',
  'pages.houseUser.detail.role.owner': 'Owner',
  'pages.houseUser.detail.role.tenant': 'Tenant',
  'pages.houseUser.detail.role.visitor': 'Visitor',
  'pages.houseUser.detail.houseType.residential': 'Residential',
  'pages.houseUser.detail.houseType.commercial': 'Commercial',
  'pages.houseUser.detail.houseType.office': 'Office',
  'pages.houseUser.detail.houseType.other': 'Other',
  'pages.houseUser.detail.parkingType.ground': 'Ground Parking',
  'pages.houseUser.detail.parkingType.underground': 'Underground Parking',
  'pages.houseUser.detail.parkingType.mechanical': 'Mechanical Parking',
  'pages.houseUser.detail.billingCycle.daily': 'Daily',
  'pages.houseUser.detail.billingCycle.monthly': 'Monthly',
  'pages.houseUser.detail.billingCycle.quarterly': 'Quarterly',
  'pages.houseUser.detail.billingCycle.yearly': 'Yearly',
  'pages.houseUser.detail.billingUnit.month': 'Month',
  'pages.houseUser.detail.billingUnit.day': 'Day',
  'pages.houseUser.detail.billingUnit.year': 'Year',
  'pages.houseUser.detail.billingUnit.unit': 'Unit',
  'pages.houseUser.detail.billingUnit.squareMeter': 'Square Meter',
  'pages.houseUser.detail.message.updateSuccess': 'Update successful',
  'pages.houseUser.detail.message.unbindSuccess': 'Unbind successful',
  'pages.houseUser.detail.message.unbindFailed': 'Unbind failed',
  'pages.houseUser.detail.message.deleteHouseSuccess':
    'House deleted successfully',
  'pages.houseUser.detail.message.deleteHouseFailed': 'Failed to delete house',
  'pages.houseUser.detail.message.deleteContactSuccess':
    'Emergency contact deleted successfully',
  'pages.houseUser.detail.message.deleteContactFailed':
    'Failed to delete emergency contact',
  'pages.houseUser.detail.message.loadHousesFailed':
    'Failed to load house list',
  'pages.houseUser.detail.message.loadParkingFailed':
    'Failed to load parking list',
  'pages.houseUser.detail.message.loadContactsFailed':
    'Failed to load emergency contacts',
  'pages.houseUser.detail.message.loadTenantsFailed':
    'Failed to load tenant list',
  'pages.houseUser.detail.message.loadRentInfoFailed':
    'Failed to load rental information',
  'pages.houseUser.detail.message.loadServicesFailed':
    'Failed to load activated services',
  'pages.houseUser.detail.confirm.unbindRent.title': 'Confirm Unbind',
  'pages.houseUser.detail.confirm.unbindRent.content':
    'Are you sure you want to terminate this rental relationship?',
  'pages.houseUser.detail.confirm.unbindTenant.title': 'Confirm Unbind',
  'pages.houseUser.detail.confirm.unbindTenant.content':
    'Are you sure you want to terminate the binding relationship with this tenant?',
  'pages.houseUser.detail.confirm.deleteContact.title': 'Confirm Delete',
  'pages.houseUser.detail.confirm.deleteContact.content':
    'Are you sure you want to delete this emergency contact?',
  'pages.houseUser.detail.confirm.okText': 'OK',
  'pages.houseUser.detail.confirm.cancelText': 'Cancel',
  'pages.houseUser.detail.empty.noHouses': 'No property data available',
  'pages.houseUser.detail.empty.noRentInfo': 'No rental information available',
  'pages.houseUser.detail.empty.noTenants': 'No tenant data available',
  'pages.houseUser.detail.empty.noParking': 'No parking data available',
  'pages.houseUser.detail.empty.noServices': 'No activated services available',
  'pages.houseUser.detail.empty.noContacts': 'No emergency contacts available',
  'pages.houseUser.detail.loading': 'Loading...',
  'pages.houseUser.detail.locationInfo': 'Location Information',
  'pages.houseUser.detail.structureCode': 'Structure Code',
  'pages.houseUser.detail.parkingType': 'Parking Type',
  'pages.houseUser.detail.startTime': 'Start Time',
  'pages.houseUser.detail.ownerInfo': 'Owner Information',
  'pages.houseUser.detail.tenantName': 'Tenant Name',
  'pages.houseUser.detail.houseInfo': 'House Information',
  'pages.houseUser.detail.monthlyRent': 'Monthly Rent',
  'pages.houseUser.detail.leaseStartDate': 'Lease Start Date',
  'pages.houseUser.detail.leaseEndDate': 'Lease End Date',
  'pages.houseUser.detail.buildingName': 'Building',
  'pages.houseUser.detail.floor': 'Floor',
  'pages.houseUser.detail.houseNumber': 'House Number',
  'pages.houseUser.detail.area': 'Area',
  'pages.houseUser.detail.amount': 'Amount',
  'pages.houseUser.detail.remarks': 'Remarks',
  'pages.houseUser.detail.serviceCount': 'Service Count',
  'pages.houseUser.detail.bindVehicle': 'Vehicle Bound',
  'pages.houseUser.detail.noVehicle': 'No Vehicle Bound',
  'pages.houseUser.detail.brandModel': 'Brand/Model',
  'pages.houseUser.detail.vehicleColor': 'Vehicle Color',
  'pages.houseUser.detail.vehicleType': 'Vehicle Type',
  'pages.houseUser.detail.registrationDate': 'Registration Date',
  'pages.houseUser.detail.bindVehicleButton': '+ Bind Vehicle',
  'pages.houseUser.detail.editVehicleButton': 'Edit',
  'pages.houseUser.detail.daysLeft': 'Expiring soon ({days} days)',
  'pages.houseUser.emergencyContact.title.view': 'View Emergency Contact',
  'pages.houseUser.emergencyContact.title.edit': 'Edit Emergency Contact',
  'pages.houseUser.emergencyContact.title.add': 'Add Emergency Contact',
  'pages.houseUser.emergencyContact.button.close': 'Close',
  'pages.houseUser.emergencyContact.button.update': 'Update',
  'pages.houseUser.emergencyContact.button.add': 'Add',
  'pages.houseUser.emergencyContact.label.ownerName': 'Owner Name',
  'pages.houseUser.emergencyContact.label.contactName': 'Contact Name',
  'pages.houseUser.emergencyContact.label.contactPhone': 'Contact Phone',
  'pages.houseUser.emergencyContact.label.relationship':
    'Relationship to Owner',
  'pages.houseUser.emergencyContact.label.remarks': 'Remarks',
  'pages.houseUser.emergencyContact.placeholder.contactName':
    'Please enter contact name',
  'pages.houseUser.emergencyContact.placeholder.contactPhone':
    'Please enter contact phone',
  'pages.houseUser.emergencyContact.placeholder.relationship':
    'E.g.: father, mother, spouse, children, etc.',
  'pages.houseUser.emergencyContact.placeholder.remarks':
    'Please enter remarks',
  'pages.houseUser.emergencyContact.validation.contactName.required':
    'Please enter contact name',
  'pages.houseUser.emergencyContact.validation.contactPhone.required':
    'Please enter contact phone',
  'pages.houseUser.emergencyContact.validation.contactPhone.invalid':
    'Please enter a valid phone number',
  'pages.houseUser.emergencyContact.validation.relationship.required':
    'Please enter relationship to owner',
  'pages.houseUser.emergencyContact.message.updateSuccess':
    'Emergency contact updated successfully',
  'pages.houseUser.emergencyContact.message.addSuccess':
    'Emergency contact added successfully',
  'pages.houseUser.emergencyContact.message.updateFailed': 'Update failed',
  'pages.houseUser.emergencyContact.message.addFailed': 'Add failed',
  'pages.houseUser.emergencyContact.message.submitFailed': 'Submission failed',
  'pages.houseUser.houseManagement.title.edit': 'Edit House Information',
  'pages.houseUser.houseManagement.title.add': 'Add New House',
  'pages.houseUser.houseManagement.label.building': 'Building',
  'pages.houseUser.houseManagement.label.floor': 'Floor',
  'pages.houseUser.houseManagement.label.unit': 'Unit Number',
  'pages.houseUser.houseManagement.label.houseNumber': 'House Number',
  'pages.houseUser.houseManagement.label.area': 'Building Area (㎡)',
  'pages.houseUser.houseManagement.label.houseType': 'House Type',
  'pages.houseUser.houseManagement.label.status': 'House Status',
  'pages.houseUser.houseManagement.label.price': 'House Value (CNY)',
  'pages.houseUser.houseManagement.label.remarks': 'Remarks',
  'pages.houseUser.houseManagement.label.ownerInfo': 'Owner Information',
  'pages.houseUser.houseManagement.label.ownerName': 'Owner Name',
  'pages.houseUser.houseManagement.label.ownerId': 'Owner ID',
  'pages.houseUser.houseManagement.placeholder.building':
    'Please select building',
  'pages.houseUser.houseManagement.placeholder.floor':
    'Please select building first',
  'pages.houseUser.houseManagement.placeholder.unit':
    'Please enter unit number (if any)',
  'pages.houseUser.houseManagement.placeholder.houseNumber':
    'Please enter house number',
  'pages.houseUser.houseManagement.placeholder.area':
    'Please enter building area',
  'pages.houseUser.houseManagement.placeholder.houseType':
    'Please select house type',
  'pages.houseUser.houseManagement.placeholder.status':
    'Please select house status',
  'pages.houseUser.houseManagement.placeholder.price':
    'Please enter house value',
  'pages.houseUser.houseManagement.placeholder.remarks': 'Please enter remarks',
  'pages.houseUser.houseManagement.validation.building.required':
    'Please select building',
  'pages.houseUser.houseManagement.validation.floor.required':
    'Please select floor',
  'pages.houseUser.houseManagement.validation.houseNumber.required':
    'Please enter house number',
  'pages.houseUser.houseManagement.validation.houseType.required':
    'Please select house type',
  'pages.houseUser.houseManagement.validation.status.required':
    'Please select house status',
  'pages.houseUser.houseManagement.message.loadBuildingsFailed':
    'Failed to load building list',
  'pages.houseUser.houseManagement.message.loadFloorsFailed':
    'Failed to load floor list',
  'pages.houseUser.houseManagement.message.updateSuccess':
    'House updated successfully',
  'pages.houseUser.houseManagement.message.createSuccess':
    'House created successfully',
  'pages.houseUser.houseManagement.message.updateFailed':
    'Failed to update house',
  'pages.houseUser.houseManagement.message.createFailed':
    'Failed to create house',
  'pages.houseUser.form.title.edit': 'Edit House User',
  'pages.houseUser.form.title.create': 'Create New House User',
  'pages.houseUser.form.label.username': 'Username',
  'pages.houseUser.form.label.password': 'Password',
  'pages.houseUser.form.label.confirmPassword': 'Confirm Password',
  'pages.houseUser.form.label.name': 'Name',
  'pages.houseUser.form.label.gender': 'Gender',
  'pages.houseUser.form.label.birthDate': 'Date of Birth',
  'pages.houseUser.form.label.idCard': 'ID Card Number',
  'pages.houseUser.form.label.phone': 'Phone Number',
  'pages.houseUser.form.label.email': 'Email',
  'pages.houseUser.form.label.address': 'Detailed Address',
  'pages.houseUser.form.label.role': 'Role',
  'pages.houseUser.form.label.status': 'Status',
  'pages.houseUser.form.label.moveInDate': 'Move-in Date',
  'pages.houseUser.form.label.moveOutDate': 'Move-out Date',
  'pages.houseUser.form.label.leaseStartDate': 'Lease Start Date',
  'pages.houseUser.form.label.leaseEndDate': 'Lease End Date',
  'pages.houseUser.form.label.monthlyRent': 'Monthly Rent (CNY)',
  'pages.houseUser.form.label.depositAmount': 'Deposit Amount (CNY)',
  'pages.houseUser.form.label.occupation': 'Occupation',
  'pages.houseUser.form.label.workUnit': 'Work Unit',
  'pages.houseUser.form.label.emergencyContact': 'Emergency Contact',
  'pages.houseUser.form.label.emergencyPhone': 'Emergency Phone',
  'pages.houseUser.form.label.remarks': 'Remarks',
  'pages.houseUser.form.placeholder.username': 'Please enter username',
  'pages.houseUser.form.placeholder.password': 'Please enter password',
  'pages.houseUser.form.placeholder.confirmPassword':
    'Please enter password again',
  'pages.houseUser.form.placeholder.name': 'Please enter name',
  'pages.houseUser.form.placeholder.gender': 'Please select gender',
  'pages.houseUser.form.placeholder.birthDate': 'Please select date of birth',
  'pages.houseUser.form.placeholder.idCard': 'Please enter ID card number',
  'pages.houseUser.form.placeholder.phone': 'Please enter phone number',
  'pages.houseUser.form.placeholder.email': 'Please enter email',
  'pages.houseUser.form.placeholder.address': 'Please enter detailed address',
  'pages.houseUser.form.placeholder.role': 'Please select role',
  'pages.houseUser.form.placeholder.status': 'Please select status',
  'pages.houseUser.form.placeholder.moveInDate': 'Please select move-in date',
  'pages.houseUser.form.placeholder.moveOutDate': 'Please select move-out date',
  'pages.houseUser.form.placeholder.leaseStartDate':
    'Please select lease start date',
  'pages.houseUser.form.placeholder.leaseEndDate':
    'Please select lease end date',
  'pages.houseUser.form.placeholder.monthlyRent': 'Please enter monthly rent',
  'pages.houseUser.form.placeholder.depositAmount':
    'Please enter deposit amount',
  'pages.houseUser.form.placeholder.occupation': 'Please enter occupation',
  'pages.houseUser.form.placeholder.workUnit': 'Please enter work unit',
  'pages.houseUser.form.placeholder.emergencyContact':
    'Please enter emergency contact',
  'pages.houseUser.form.placeholder.emergencyPhone':
    'Please enter emergency phone',
  'pages.houseUser.form.placeholder.remarks': 'Please enter remarks',
  'pages.houseUser.form.validation.username.required': 'Please enter username',
  'pages.houseUser.form.validation.username.minLength':
    'Username must be at least 4 characters',
  'pages.houseUser.form.validation.username.pattern':
    'Username can only contain letters, numbers, and underscores',
  'pages.houseUser.form.validation.password.required': 'Please enter password',
  'pages.houseUser.form.validation.password.minLength':
    'Password must be at least 6 characters',
  'pages.houseUser.form.validation.confirmPassword.required':
    'Please enter password again',
  'pages.houseUser.form.validation.confirmPassword.mismatch':
    'Passwords do not match',
  'pages.houseUser.form.validation.name.required': 'Please enter name',
  'pages.houseUser.form.validation.name.minLength':
    'Name must be at least 2 characters',
  'pages.houseUser.form.validation.gender.required': 'Please select gender',
  'pages.houseUser.form.validation.idCard.required':
    'Please enter ID card number',
  'pages.houseUser.form.validation.idCard.pattern':
    'Please enter a valid ID card number',
  'pages.houseUser.form.validation.phone.required': 'Please enter phone number',
  'pages.houseUser.form.validation.phone.pattern':
    'Please enter a valid phone number',
  'pages.houseUser.form.validation.email.pattern':
    'Please enter a valid email format',
  'pages.houseUser.form.validation.role.required': 'Please select role',
  'pages.houseUser.form.validation.status.required': 'Please select status',
  'pages.houseUser.form.button.update': 'Update',
  'pages.houseUser.form.button.create': 'Create',
  'pages.houseUser.form.button.cancel': 'Cancel',
  'pages.houseUser.form.message.updateSuccess': 'Update successful',
  'pages.houseUser.form.message.createSuccess': 'Create successful',
  'pages.houseUser.form.message.updateFailed': 'Update failed',
  'pages.houseUser.form.message.createFailed': 'Create failed',
  'pages.houseUser.form.message.operationFailed': 'Operation failed',
  'pages.houseUser.formNew.title.edit': 'Edit House User',
  'pages.houseUser.formNew.title.create': 'Create New House User',
  'pages.houseUser.formNew.section.accountInfo': 'Account Information',
  'pages.houseUser.formNew.section.basicInfo': 'Basic Information',
  'pages.houseUser.formNew.section.contactInfo': 'Contact Information',
  'pages.houseUser.formNew.section.residenceInfo': 'Residence Information',
  'pages.houseUser.formNew.section.leaseInfo': 'Lease Information',
  'pages.houseUser.formNew.section.remarks': 'Remarks',
  'pages.houseUser.formNew.label.username': 'Username',
  'pages.houseUser.formNew.label.role': 'Role',
  'pages.houseUser.formNew.label.status': 'Account Status',
  'pages.houseUser.formNew.label.password': 'Password',
  'pages.houseUser.formNew.label.confirmPassword': 'Confirm Password',
  'pages.houseUser.formNew.label.name': 'Name',
  'pages.houseUser.formNew.label.gender': 'Gender',
  'pages.houseUser.formNew.label.birthDate': 'Date of Birth',
  'pages.houseUser.formNew.label.idCard': 'ID Card Number',
  'pages.houseUser.formNew.label.phone': 'Phone Number',
  'pages.houseUser.formNew.label.email': 'Email',
  'pages.houseUser.formNew.label.address': 'Detailed Address',
  'pages.houseUser.formNew.label.moveInDate': 'Move-in Date',
  'pages.houseUser.formNew.label.moveOutDate': 'Move-out Date',
  'pages.houseUser.formNew.label.leaseStartDate': 'Lease Start Date',
  'pages.houseUser.formNew.label.leaseEndDate': 'Lease End Date',
  'pages.houseUser.formNew.label.monthlyRent': 'Monthly Rent',
  'pages.houseUser.formNew.label.depositAmount': 'Deposit Amount',
  'pages.houseUser.formNew.label.remarks': 'Remarks',
  'pages.houseUser.formNew.placeholder.username': 'Please enter username',
  'pages.houseUser.formNew.placeholder.role': 'Please select role',
  'pages.houseUser.formNew.placeholder.status': 'Please select status',
  'pages.houseUser.formNew.placeholder.password': 'Please enter password',
  'pages.houseUser.formNew.placeholder.confirmPassword':
    'Please enter password again',
  'pages.houseUser.formNew.placeholder.name': 'Please enter name',
  'pages.houseUser.formNew.placeholder.gender': 'Please select gender',
  'pages.houseUser.formNew.placeholder.birthDate':
    'Please select date of birth',
  'pages.houseUser.formNew.placeholder.idCard': 'Please enter ID card number',
  'pages.houseUser.formNew.placeholder.phone': 'Please enter phone number',
  'pages.houseUser.formNew.placeholder.email': 'Please enter email',
  'pages.houseUser.formNew.placeholder.address':
    'Please enter detailed address',
  'pages.houseUser.formNew.placeholder.moveInDate':
    'Please select move-in date',
  'pages.houseUser.formNew.placeholder.moveOutDate':
    'Please select move-out date',
  'pages.houseUser.formNew.placeholder.leaseStartDate':
    'Please select lease start date',
  'pages.houseUser.formNew.placeholder.leaseEndDate':
    'Please select lease end date',
  'pages.houseUser.formNew.placeholder.monthlyRent':
    'Please enter monthly rent',
  'pages.houseUser.formNew.placeholder.depositAmount':
    'Please enter deposit amount',
  'pages.houseUser.formNew.placeholder.remarks': 'Please enter remarks',
  'pages.houseUser.formNew.validation.username.required':
    'Please enter username',
  'pages.houseUser.formNew.validation.username.minLength':
    'Username must be at least 4 characters',
  'pages.houseUser.formNew.validation.username.pattern':
    'Username can only contain letters, numbers, and underscores',
  'pages.houseUser.formNew.validation.role.required': 'Please select role',
  'pages.houseUser.formNew.validation.status.required': 'Please select status',
  'pages.houseUser.formNew.validation.password.required':
    'Please enter password',
  'pages.houseUser.formNew.validation.password.minLength':
    'Password must be at least 6 characters',
  'pages.houseUser.formNew.validation.confirmPassword.required':
    'Please enter password again',
  'pages.houseUser.formNew.validation.confirmPassword.mismatch':
    'Passwords do not match',
  'pages.houseUser.formNew.validation.name.required': 'Please enter name',
  'pages.houseUser.formNew.validation.name.minLength':
    'Name must be at least 2 characters',
  'pages.houseUser.formNew.validation.gender.required': 'Please select gender',
  'pages.houseUser.formNew.validation.idCard.required':
    'Please enter ID card number',
  'pages.houseUser.formNew.validation.phone.required':
    'Please enter phone number',
  'pages.houseUser.formNew.validation.email.pattern':
    'Please enter a valid email format',
  'pages.houseUser.formNew.validation.remarks.maxLength':
    'Remarks cannot exceed 500 characters',
  'pages.houseUser.formNew.button.update': 'Update',
  'pages.houseUser.formNew.button.create': 'Create',
  'pages.houseUser.formNew.button.cancel': 'Cancel',
  'pages.houseUser.formNew.message.updateSuccess': 'Update successful',
  'pages.houseUser.formNew.message.createSuccess': 'Create successful',
  'pages.houseUser.formNew.message.updateFailed': 'Update failed',
  'pages.houseUser.formNew.message.createFailed': 'Create failed',
  'pages.houseUser.formNew.message.operationFailed': 'Operation failed',
  'pages.houseUser.table.title': 'House User List',
  'pages.houseUser.table.button.add': 'Create New House User',
  'pages.houseUser.table.column.userInfo': 'User Information',
  'pages.houseUser.table.column.contactInfo': 'Contact Information',
  'pages.houseUser.table.column.phone': 'Phone Number',
  'pages.houseUser.table.column.email': 'Email',
  'pages.houseUser.table.column.emailPlaceholder': 'Please enter email address',
  'pages.houseUser.table.column.houseNumber': 'House Number',
  'pages.houseUser.table.column.houseNumberPlaceholder': 'Enter house number',
  'pages.houseUser.table.column.building': 'Building',
  'pages.houseUser.table.column.buildingPlaceholder': 'Select building',
  'pages.houseUser.table.column.gender': 'Gender',
  'pages.houseUser.table.column.role': 'Role',
  'pages.houseUser.table.column.status': 'Status',
  'pages.houseUser.table.column.houseInfo': 'Property Information',
  'pages.houseUser.table.column.moveInDate': 'Move-in Date',
  'pages.houseUser.table.column.createTime': 'Create Time',
  'pages.houseUser.table.column.operations': 'Operations',
  'pages.houseUser.table.button.view': 'View',
  'pages.houseUser.table.button.enable': 'Enable',
  'pages.houseUser.table.button.disable': 'Disable',
  'pages.houseUser.table.confirm.enable.title':
    'Are you sure you want to enable this user?',
  'pages.houseUser.table.confirm.enable.description':
    'After enabling, the user will return to normal use',
  'pages.houseUser.table.confirm.disable.title':
    'Are you sure you want to disable this user?',
  'pages.houseUser.table.confirm.disable.description':
    'After disabling, the user will not be able to use normally',
  'pages.houseUser.table.confirm.okText': 'OK',
  'pages.houseUser.table.confirm.cancelText': 'Cancel',
  'pages.houseUser.table.message.enableSuccess': 'Enable successful',
  'pages.houseUser.table.message.disableSuccess': 'Disable successful',
  'pages.houseUser.table.message.enableFailed': 'Enable failed',
  'pages.houseUser.table.message.disableFailed': 'Disable failed',
  'pages.houseUser.tenant.title.edit': 'Edit Tenant',
  'pages.houseUser.tenant.title.add': 'Add Tenant',
  'pages.houseUser.tenant.label.house': 'Select Property',
  'pages.houseUser.tenant.label.tenant': 'Select Tenant',
  'pages.houseUser.tenant.label.leaseStartDate': 'Lease Start Date',
  'pages.houseUser.tenant.label.leaseEndDate': 'Lease End Date',
  'pages.houseUser.tenant.label.monthlyRent': 'Monthly Rent',
  'pages.houseUser.tenant.label.remarks': 'Remarks',
  'pages.houseUser.tenant.placeholder.house': 'Please select property',
  'pages.houseUser.tenant.placeholder.houseLoading': 'Loading...',
  'pages.houseUser.tenant.placeholder.tenant':
    'Enter tenant name, phone or email',
  'pages.houseUser.tenant.placeholder.leaseStartDate':
    'Please select lease start date',
  'pages.houseUser.tenant.placeholder.leaseEndDate':
    'Please select lease end date',
  'pages.houseUser.tenant.placeholder.monthlyRent': 'Please enter monthly rent',
  'pages.houseUser.tenant.placeholder.remarks': 'Please enter remarks',
  'pages.houseUser.tenant.validation.house.required': 'Please select property',
  'pages.houseUser.tenant.validation.tenant.required': 'Please select tenant',
  'pages.houseUser.tenant.message.loadHousesFailed':
    'Failed to load property list',
  'pages.houseUser.tenant.message.searchFailed': 'Search user failed',
  'pages.houseUser.tenant.message.selectHouseAndTenant':
    'Please select property and tenant',
  'pages.houseUser.tenant.message.updateSuccess': 'Update successful',
  'pages.houseUser.tenant.message.createSuccess': 'Create successful',
  'pages.houseUser.tenant.message.updateFailed': 'Update failed',
  'pages.houseUser.tenant.message.createFailed': 'Create failed',
  'pages.houseUser.tenant.text.rented': ' (Rented)',
  'pages.houseUser.tenant.text.invalidTenant':
    ' (Not selectable - not visitor role)',
  'pages.houseUser.vehicle.title.edit': 'Edit Vehicle',
  'pages.houseUser.vehicle.title.add': 'Bind Vehicle',
  'pages.houseUser.vehicle.section.parkingInfo': 'Parking Information',
  'pages.houseUser.vehicle.section.basicInfo': 'Basic Information',
  'pages.houseUser.vehicle.section.remarks': 'Remarks',
  'pages.houseUser.vehicle.label.parking': 'Parking Space',
  'pages.houseUser.vehicle.label.plateNumber': 'License Plate Number',
  'pages.houseUser.vehicle.label.vehicleType': 'Vehicle Type',
  'pages.houseUser.vehicle.label.brand': 'Brand',
  'pages.houseUser.vehicle.label.model': 'Model',
  'pages.houseUser.vehicle.label.color': 'Vehicle Color',
  'pages.houseUser.vehicle.label.registrationDate': 'Registration Date',
  'pages.houseUser.vehicle.label.remarks': 'Remarks',
  'pages.houseUser.vehicle.placeholder.plateNumber':
    'Please enter license plate number',
  'pages.houseUser.vehicle.placeholder.vehicleType':
    'Please select vehicle type',
  'pages.houseUser.vehicle.placeholder.brand':
    'Please enter brand, e.g.: Mercedes, Toyota',
  'pages.houseUser.vehicle.placeholder.model':
    'Please enter model, e.g.: C-Class, Corolla',
  'pages.houseUser.vehicle.placeholder.color': 'Please enter vehicle color',
  'pages.houseUser.vehicle.placeholder.registrationDate':
    'Please select registration date',
  'pages.houseUser.vehicle.placeholder.remarks': 'Please enter remarks',
  'pages.houseUser.vehicle.validation.plateNumber.required':
    'Please enter license plate number',
  'pages.houseUser.vehicle.validation.plateNumber.maxLength':
    'License plate number cannot exceed 20 characters',
  'pages.houseUser.vehicle.validation.vehicleType.required':
    'Please select vehicle type',
  'pages.houseUser.vehicle.validation.brand.maxLength':
    'Brand cannot exceed 50 characters',
  'pages.houseUser.vehicle.validation.model.maxLength':
    'Model cannot exceed 50 characters',
  'pages.houseUser.vehicle.validation.color.maxLength':
    'Color cannot exceed 20 characters',
  'pages.houseUser.vehicle.validation.remarks.maxLength':
    'Remarks cannot exceed 500 characters',
  'pages.houseUser.vehicle.message.updateSuccess': 'Update successful',
  'pages.houseUser.vehicle.message.createSuccess': 'Create successful',
  'pages.houseUser.vehicle.message.updateFailed': 'Update failed',
  'pages.houseUser.vehicle.message.createFailed': 'Create failed',
  'pages.houseUser.table.headerTitle': 'House User List',
  'pages.houseUser.table.column.emailValidation.pattern':
    'Please enter a valid email format',
  'pages.houseUser.table.pagination.showTotal':
    'Items {start}-{end} of {total}',
  'pages.houseUser.table.role.owner': 'Owner',
  'pages.houseUser.table.role.tenant': 'Tenant',
  'pages.houseUser.table.role.visitor': 'Visitor',
  'pages.houseUser.table.status.normal': 'Normal',
  'pages.houseUser.table.status.disabled': 'Disabled',
  'pages.houseUser.table.status.other': 'Other',
  'pages.houseUser.table.gender.male': 'Male',
  'pages.houseUser.table.gender.female': 'Female',
  'pages.houseUser.formNew.gender.male': 'Male',
  'pages.houseUser.formNew.gender.female': 'Female',
  'pages.houseUser.formNew.gender.other': 'Other',
  'pages.houseUser.formNew.role.owner': 'Owner',
  'pages.houseUser.formNew.role.tenant': 'Tenant',
  'pages.houseUser.formNew.role.visitor': 'Visitor',
  'pages.houseUser.formNew.status.normal': 'Normal',
  'pages.houseUser.formNew.status.disabled': 'Disabled',
  'pages.houseUser.detail.editButton': 'Edit',
  'pages.houseUser.detail.label.idCardNumber': 'ID Card Number',
  'pages.houseUser.detail.status.normal': 'Normal',
  'pages.houseUser.detail.parkingStatus.available': 'Available',
  'pages.houseUser.detail.parkingStatus.sold': 'Sold',
  'pages.houseUser.detail.parkingStatus.rented': 'Rented',
  'pages.houseUser.detail.parkingStatus.reserved': 'Reserved',
  'pages.houseUser.detail.parkingStatus.disabled': 'Disabled',
  'pages.houseUser.detail.text.locationInfo': 'Location Information',
  'pages.houseUser.detail.text.structureCode': 'Structure Code',
  'pages.houseUser.detail.text.parkingType': 'Parking Type',
  'pages.houseUser.detail.text.startTime': 'Start Time',
  'pages.houseUser.detail.text.ownerInfo': 'Owner Information',
  'pages.houseUser.detail.files.search.placeholder': 'Search file name',
  'pages.houseUser.detail.files.button.upload': 'Upload New File',
  'pages.houseUser.detail.files.empty': 'No files',
  'pages.houseUser.detail.files.message.loadListFailed':
    'Failed to load file list',
  'pages.houseUser.detail.files.message.selectFile':
    'Please select a file to upload',
  'pages.houseUser.detail.files.message.uploadFailed': 'File upload failed',
  'pages.houseUser.detail.files.message.uploadedButNoPath':
    'File uploaded, but failed to get file path',
  'pages.houseUser.detail.files.message.uploadSuccess':
    'File uploaded successfully',
  'pages.houseUser.detail.files.message.saveRecordFailed':
    'Failed to save file record',
  'pages.houseUser.detail.files.message.loadDetailFailed':
    'Failed to load file details',
  'pages.houseUser.detail.files.confirm.delete.title': 'Confirm deletion',
  'pages.houseUser.detail.files.confirm.delete.content':
    'Are you sure you want to delete this file? This action cannot be undone.',
  'pages.houseUser.detail.files.confirm.delete.okText': 'Delete',
  'pages.houseUser.detail.files.confirm.delete.cancelText': 'Cancel',
  'pages.houseUser.detail.files.message.deleteSuccess': 'Deleted successfully',
  'pages.houseUser.detail.files.message.deleteFailed': 'Delete failed',
  'pages.houseUser.detail.text.tenantName': 'Tenant Name',
  'pages.houseUser.detail.text.houseInfo': 'House Information',
  'pages.houseUser.detail.text.monthlyRent': 'Monthly Rent',
  'pages.houseUser.detail.text.leaseStartDate': 'Lease Start Date',
  'pages.houseUser.detail.text.leaseEndDate': 'Lease End Date',
  'pages.houseUser.detail.text.buildingName': 'Building',
  'pages.houseUser.detail.text.floor': 'Floor',
  'pages.houseUser.detail.text.houseNumber': 'House Number',
  'pages.houseUser.detail.text.area': 'Area',
  'pages.houseUser.detail.text.amount': 'Amount',
  'pages.houseUser.detail.text.remarks': 'Remarks',
  'pages.houseUser.detail.text.serviceCount': 'Service Count',
  'pages.houseUser.detail.text.bindVehicle': 'Vehicle Bound',
  'pages.houseUser.detail.text.noVehicle': 'No Vehicle Bound',
  'pages.houseUser.detail.text.brandModel': 'Brand/Model',
  'pages.houseUser.detail.text.vehicleColor': 'Vehicle Color',
  'pages.houseUser.detail.text.vehicleType': 'Vehicle Type',
  'pages.houseUser.detail.text.registrationDate': 'Registration Date',
  'pages.houseUser.detail.text.bindVehicleButton': '+ Bind Vehicle',
  'pages.houseUser.detail.text.editVehicleButton': 'Edit',
  'pages.houseUser.detail.text.daysLeft': 'Expiring soon ({days} days)',
  'pages.houseUser.detail.text.addTenant': '+ Add Tenant',
  'pages.houseUser.detail.text.parkingList': 'Parking Space List',
  'pages.houseUser.detail.text.boundVehicles': 'Bound Vehicles',
  'pages.houseUser.detail.text.noVehicles': 'No Vehicles',
  'pages.houseUser.detail.text.openedServices': 'Activated Services',
  'pages.houseUser.detail.text.noOpenedServices': 'No activated services',
  'pages.houseUser.detail.text.emergencyContactsList':
    'Emergency Contacts List',
  'pages.houseUser.detail.text.addContact': 'Add Contact',
  'pages.houseUser.detail.text.noEmergencyContacts': 'No emergency contacts',
  'pages.houseUser.detail.text.mobileNumber': 'Mobile Number',
  'pages.houseUser.detail.text.emailAddress': 'Email Address',
  'pages.houseUser.detail.text.checkInDate': 'Check-in Date',
  'pages.houseUser.detail.text.houseInformation': 'House Information',
  'pages.houseUser.detail.text.building': 'Building:',
  'pages.houseUser.detail.text.floorLevel': 'Floor:',
  'pages.houseUser.detail.text.houseNumberLabel': 'House Number:',
  'pages.houseUser.detail.text.servicesCount': 'Services Count:',
  'pages.houseUser.detail.text.serviceName': 'Service Name',
  'pages.houseUser.detail.text.enabled': 'Enabled',
  'pages.houseUser.detail.text.paused': 'Paused',
  'pages.houseUser.detail.text.disabled': 'Disabled',
  'pages.houseUser.detail.text.rentedHouse': 'Rented House',
  'pages.houseUser.detail.text.rent': 'Monthly Rent',
  'pages.houseUser.detail.text.leaseStart': 'Lease Start',
  'pages.houseUser.detail.text.leaseEnd': 'Lease End',
  'pages.houseUser.detail.text.renting': 'Renting',
  'pages.houseUser.detail.text.parkingNumber': 'Parking Number: ',
  'pages.houseUser.detail.text.parkingStatus': 'Parking Status',
  'pages.houseUser.detail.text.vehicleInfo': 'Vehicle Information',
  'pages.houseUser.detail.text.serviceInfo': 'Service Information',
};
